'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _RestaurantInfoModal = require('../common/RestaurantInfoModal');

var _RestaurantInfoModal2 = _interopRequireDefault(_RestaurantInfoModal);

var _LoginForm = require('../login/LoginForm');

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _ScheduleOrderModal = require('../schedule/ScheduleOrderModal');

var _ScheduleOrderModal2 = _interopRequireDefault(_ScheduleOrderModal);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _LoginStore = require('../../stores/LoginStore');

var _LoginStore2 = _interopRequireDefault(_LoginStore);

var _Utility = require('../../utils/Utility');

var Utility = _interopRequireWildcard(_Utility);

var Utils = _interopRequireWildcard(_Utility);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PICKUP = Constants.PICKUP;
var CURBSIDEPICKUP = Constants.CURBSIDEPICKUP;
var DINEIN = Constants.DINEIN;
var DELIVERY = Constants.DELIVERY;
//wrapper functional component to pass params as props to main file.
function withReactRouter(Component) {
	function ComponentWithReactRouter(props) {
		// const navigate = useNavigate();
		var history = (0, _reactRouterDom.useHistory)();
		var params = (0, _reactRouterDom.useParams)();
		return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
			params: params

		}));
	}
	return ComponentWithReactRouter;
}

var Header = function (_React$Component) {
	_inherits(Header, _React$Component);

	function Header(props) {
		_classCallCheck(this, Header);

		var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

		_this.state = {
			showRestaurantInfoModal: false,
			showLoginModal: false,
			ShowScheduleOrderModal: false,
			orderType: PICKUP,
			title: "Please Sign In",
			cartBadge: 0,
			LocationDetail: null,
			searchTerm: "",
			isMobile: false
		};

		_this.changeLocation = _this.changeLocation.bind(_this);
		_this.handleShowRestaurantInfoModal = _this.handleShowRestaurantInfoModal.bind(_this);
		_this.handleHideModal = _this.handleHideModal.bind(_this);
		_this.handleLogin = _this.handleLogin.bind(_this);
		_this.handlePastOrders = _this.handlePastOrders.bind(_this);
		_this.handleShowScheduleOrderModal = _this.handleShowScheduleOrderModal.bind(_this);
		_this.handleCheckout = _this.handleCheckout.bind(_this);
		_this.changeModalTitle = _this.changeModalTitle.bind(_this);
		_this.loginInformation = _this.loginInformation.bind(_this);
		_this.handleLogOut = _this.handleLogOut.bind(_this);
		_this.onLoginChange = _this.onLoginChange.bind(_this);
		_this.onCartChange = _this.onCartChange.bind(_this);
		_this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
		return _this;
	}

	_createClass(Header, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			// listen to schedule screen store changes
			// ScheduleScreenStore.listen(this.onScheduleStoreChange);
			_LoginStore2.default.listen(this.onLoginChange);
			_CartStore2.default.listen(this.onCartChange);

			var width = window.innerWidth;
			var mobView = width < 993 ? true : false;

			var self = this;
			self.setState({
				cartBadge: _CartStore2.default.getCartCount(),
				orderType: _CartStore2.default.getOrderType(),
				isMobile: mobView
			});

			// Default call the update window dimensions
			window.addEventListener('scroll', this.handleScroll);
			//add resize browser window listener
			window.addEventListener("resize", this.updateWindowDimensions);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener("scroll", this.handleScroll);
			//remove resize browser window listener
			window.removeEventListener("resize", this.updateWindowDimensions);

			//hide modal if open while unmounting
			if ($('#loginModal').hasClass('show')) {
				// The modal is open, so you can hide it
				$('#loginModal').modal('hide');
			}
		}
	}, {
		key: 'updateWindowDimensions',
		value: function updateWindowDimensions() {

			var width = window.innerWidth;

			this.setState({
				isMobile: width < 993 ? true : false
			});
		}
	}, {
		key: 'handleScroll',
		value: function handleScroll(e) {
			//hide drop-down on scroll
			// $("#dropdown-toggle").collapse('hide');
			$('#navbarNavDropdown').collapse('hide');
			$('#accountDropDown').collapse('hide');
		}
	}, {
		key: 'onLoginChange',
		value: function onLoginChange(event, currentUser) {
			this.setState({ currentUser: currentUser });
		}
	}, {
		key: 'onCartChange',
		value: function onCartChange(event, cartStore) {

			var self = this;
			var CartCount = _CartStore2.default.getCartCount();

			self.setState({
				cartBadge: CartCount,
				orderType: _CartStore2.default.getOrderType()
			});
		}
	}, {
		key: 'changeLocation',
		value: function changeLocation() {
			var history = this.props.history;
			// Navigate to Another Component

			history.push("/");
		}
	}, {
		key: 'handlePastOrders',
		value: function handlePastOrders(event, navigate) {
			event.preventDefault();
			var history = this.props.history;

			var locId = this.props.params.locId;

			if (navigate === "orders") {
				history.push({
					pathname: '/location/' + locId + '/orders',
					resetStore: false
				});
			} else if (navigate === "payments") {
				history.push({
					pathname: '/location/' + locId + '/payments',
					resetStore: false
				});
			} else if (navigate === "address") {
				history.push({
					pathname: '/location/' + locId + '/addresses',
					resetStore: false
				});
			} else if (navigate === "profile") {
				history.push({
					pathname: '/location/' + locId + '/orders/profile',
					resetStore: false
				});
			} else if (navigate === "home") {
				history.push({
					pathname: "/location/" + locId,
					resetStore: false
				});
			}
		}
	}, {
		key: 'handleCheckout',
		value: function handleCheckout(e) {

			e.preventDefault();

			var history = this.props.history;

			var locId = this.props.params.locId;

			if (!(_CartStore2.default.getCartItems().length === 0)) {
				history.push('/location/' + this.props.params.locId + '/checkout');
			} else {

				_sweetalert2.default.fire({
					title: "Oops! No item in the cart.",
					text: "Your cart is empty add items to get started.",
					icon: 'warning',
					showConfirmButton: false,
					showCancelButton: true,
					cancelButtonText: 'Close',
					customClass: {
						cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
					},
					allowOutsideClick: false
				});
			}
		}
	}, {
		key: 'handleLogin',
		value: function handleLogin(e) {
			e.preventDefault();

			this.setState({
				showLoginModal: true
			}, function () {
				$('#loginModal').modal('show');
			});
		}
	}, {
		key: 'handleShowRestaurantInfoModal',
		value: function handleShowRestaurantInfoModal(e) {
			e.preventDefault();
			this.setState({
				view: { showModal: true },
				showRestaurantInfoModal: true
			});
		}
	}, {
		key: 'handleShowScheduleOrderModal',
		value: function handleShowScheduleOrderModal() {
			this.setState({
				ShowScheduleOrderModal: true
			});
		}
	}, {
		key: 'handleHideModal',
		value: function handleHideModal(status) {
			this.setState({
				showRestaurantInfoModal: false,
				showLoginModal: false,
				ShowScheduleOrderModal: false,
				title: "Please Sign In"
			});
		}
	}, {
		key: 'loginInformation',
		value: function loginInformation(isSuccess) {
			if (isSuccess) {
				this.handleHideModal();
				$('#loginModal').modal('hide');
			}
		}
	}, {
		key: 'renderLocationChangeComponent',
		value: function renderLocationChangeComponent() {
			return _react2.default.createElement(
				'div',
				{ className: 'dropdown-menu dropdown-menu-loc p-0 shadow border-1',
					'data-popper-placement': 'bottom-start', id: "dropdown-toggle" },
				_react2.default.createElement(
					'div',
					{ className: 'osahan-country' },
					_react2.default.createElement(
						'div',
						{ className: 'p-3 text-end border-bottom' },
						_react2.default.createElement(
							'div',
							{ className: 'input-group bg-white rounded search_location' },
							_react2.default.createElement(
								'span',
								{
									className: 'input-group-text bg-transparent border-0 rounded-0' },
								_react2.default.createElement('i', {
									className: 'icofont-search' })
							),
							_react2.default.createElement('input', { type: 'text',
								className: 'form-control form-search-control bg-transparent border-0 rounded-0 px-0 shadow-none',
								placeholder: 'Search Your Location',
								'aria-label': 'Search Your Location',
								onChange: this.handleSearch.bind(this),
								tabIndex: 2
							})
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'filter' },
						this.renderDropDownLocComponent(),
						_react2.default.createElement(
							'div',
							{ className: 'border-bottom p-3', id: "dropdown-loc", style: { display: "none" } },
							_react2.default.createElement(
								'div',
								{ className: 'm-0' },
								_react2.default.createElement(
									'p',
									{ className: "mb-0 text-start w-100" + " text-dark" + " font-weight-bold" },
									'No Match Found.'
								)
							)
						)
					)
				)
			);
		}
	}, {
		key: 'renderLocationAndOrderTypeMobComponent',
		value: function renderLocationAndOrderTypeMobComponent() {

			var activeLocation = _MainStore2.default.getActiveLocation();

			var locationCityState = "";
			var locationName = "";
			var address = "";
			if (!Utility.isEmptyObj(activeLocation)) {
				locationCityState = activeLocation.city + ", " + activeLocation.state;
				locationName = activeLocation.name;

				var addressString1 = activeLocation.addLine1;
				// Address
				var addressString2 = activeLocation.city + ', ' + activeLocation.state + ' ' + activeLocation.zipCode;
				address = addressString1.toUpperCase() + ", " + addressString2.toUpperCase();
			} else {
				return null;
			}

			return _react2.default.createElement(
				'div',
				{ className: "position-relative d-inline-block" },
				_react2.default.createElement(
					'a',
					_defineProperty({ className: 'nav-link-loc',
						'aria-haspopup': 'true', 'data-toggle': 'dropdown' }, 'aria-haspopup', 'true'),
					_react2.default.createElement('i', { className: 'icofont-location-pin mob-loc-dropdown' }),
					' ',
					_react2.default.createElement(
						'span',
						{ className: "mob-dropdown" },
						locationName
					)
				),
				this.renderLocationChangeComponent()
			);
		}
	}, {
		key: 'getPickUpTab',
		value: function getPickUpTab() {

			var component = null;
			// const isPickUpOrderDisabled = MainStore.isPickUpOrderDisabled();
			var locationDineInOnly = _MainStore2.default.isLocationForDineInOnly();

			// if(!isPickUpOrderDisabled && !locationDineInOnly){
			if (!locationDineInOnly) {

				var activeClass = this.state.orderType == "PickUp" ? "header-btn-active" : "";
				component = _react2.default.createElement(
					_SimpleButton2.default,
					{
						classNames: "header-btn ft-14 " + activeClass,
						id: 'btn-social-login',
						tabIndex: 3

					},
					_react2.default.createElement(
						'span',
						{ className: 'pl-2 px-2' },
						'PickUp'
					)
				);
			}

			return component;
		}
	}, {
		key: 'getDeliveryTab',
		value: function getDeliveryTab() {

			var component = null;

			var locationDineInOnly = _MainStore2.default.isLocationForDineInOnly();
			if (!locationDineInOnly) {

				var activeClass = this.state.orderType == "Delivery" ? "header-btn-active" : "";

				component = _react2.default.createElement(
					_SimpleButton2.default,
					{
						classNames: "header-btn ft-14 " + activeClass,
						id: 'btn-delivery',
						tabIndex: 3
					},
					_react2.default.createElement(
						'span',
						{ className: 'pl-2 px-2' },
						'Delivery'
					)
				);
			}

			return component;
		}
	}, {
		key: 'getDineInTab',
		value: function getDineInTab() {

			var component = null;
			var isDineInEnabled = _MainStore2.default.isDineInEnabled();
			var activeClass = this.state.orderType == "DineIn" ? "header-btn-active" : "";
			if (isDineInEnabled) {
				component = _react2.default.createElement(
					_SimpleButton2.default,
					{
						classNames: "header-btn ft-14 " + activeClass,
						id: 'btn-dineIn',
						tabIndex: 3
					},
					_react2.default.createElement(
						'span',
						{ className: 'pl-2 px-2' },
						'DineIn'
					)
				);
			} else {
				component = null;
			}
			return component;
		}
	}, {
		key: 'handleSearch',
		value: function handleSearch(e) {
			this.setState({
				searchTerm: e.target.value
			});
		}
	}, {
		key: 'handleLocationChange',
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(locId) {
				var history;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								history = this.props.history;

								if (!(!_CartStore2.default.getCartCount() == 0)) {
									_context.next = 6;
									break;
								}

								_context.next = 4;
								return _sweetalert2.default.fire({
									title: "Are you sure ?",
									text: "Changing location will remove all items from cart.",
									icon: 'warning',
									showCancelButton: true,
									cancelButtonColor: '#d33',
									confirmButtonText: 'Yes',
									cancelButtonText: 'No',
									customClass: {
										confirmButton: "bg-styl",
										cancelButton: "swal2-confirm custom-btn-outline-primary custom-primary"
									},
									allowOutsideClick: false

								}).then(function (result) {
									if (result.isConfirmed) {
										history.replace("/location/" + locId, {});
										_Actions2.default.clearScheduleScreenStore(true);
										_Actions2.default.clearCartStore();
										_Actions2.default.resetPaymentMethod();
									}
								});

							case 4:
								_context.next = 7;
								break;

							case 6:
								history.push({
									pathname: "/location/" + locId
									// resetStore: false
								});

							case 7:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function handleLocationChange(_x) {
				return _ref.apply(this, arguments);
			}

			return handleLocationChange;
		}()
	}, {
		key: 'renderDropDownLocComponent',
		value: function renderDropDownLocComponent() {
			var _this2 = this;

			var businessData = _MainStore2.default.getMainScreenDataSet();
			var businessLocations = [];

			if (!Utils.isEmptyObj(businessData)) {

				if (businessData.BusinessLocations.length > 1) {
					businessLocations = businessData.BusinessLocations;
				}
			}

			var activeLocation = _MainStore2.default.getActiveLocation();
			var searchTerm = this.state.searchTerm;

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				businessLocations.filter(function (val) {

					if (searchTerm == "") {
						return val;
					} else if (val.name.toLowerCase().includes(searchTerm.toLowerCase())) {
						return val;
					} else {
						document.getElementById("dropdown-loc").style.display = "block";
					}
				}).map(function (locData, index) {

					if (!Utils.isEmptyObj(locData)) {
						var alertBox = document.getElementById("dropdown-loc");
						if (alertBox) {
							alertBox.style.display = "none";
						}
					}

					return _react2.default.createElement(
						'div',
						{ className: 'border-bottom p-3 dropdown-item', key: "loc" + index },
						_react2.default.createElement(
							'div',
							{ className: 'form-check form-check-reverse m-0',
								onClick: _this2.handleLocationChange.bind(_this2, locData.objectId)
								// onClick={() => this.handleLocationChange(locData.objectId)}
							},
							_react2.default.createElement(
								'label',
								{ className: 'container-radio m-0 p-0 ' + (activeLocation.name == locData.name ? "font-weight-bold" : ""), 'aria-checked': 'false' },
								_react2.default.createElement(
									'span',
									{ className: "pull-left text-start mr-5" },
									locData.name
								),
								_react2.default.createElement('input', {
									type: 'radio',
									name: locData.name,
									checked: activeLocation.name == locData.name
									// readOnly
									, onChange: _this2.handleLocationChange.bind(_this2, locData.objectId),
									tabIndex: 2
								}),
								_react2.default.createElement('span', { className: 'checkmark-radio ' })
							)
						)
					);
				})
			);
		}
	}, {
		key: 'renderLocationAndOrderTypeComponent',
		value: function renderLocationAndOrderTypeComponent(businessSupportMultiLocations) {

			var activeLocation = _MainStore2.default.getActiveLocation();

			var locationCityState = "";
			var locationName = "";
			var address = "";
			if (!Utility.isEmptyObj(activeLocation)) {
				locationCityState = activeLocation.city + ", " + activeLocation.state;
				locationName = activeLocation.name;

				var addressString1 = activeLocation.addLine1;
				// Address
				var addressString2 = activeLocation.city + ', ' + activeLocation.state + ' ' + activeLocation.zipCode;
				address = addressString1.toUpperCase() + ", " + addressString2.toUpperCase();
			} else {
				return null;
			}

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					'div',
					{ className: 'collapse navbar-collapse' },
					_react2.default.createElement(
						'ul',
						{ className: 'navbar-nav', id: "change-loc" },
						businessSupportMultiLocations ? _react2.default.createElement(
							'li',
							{ className: 'nav-item dropdown dropdown-cart', key: "address" },
							_react2.default.createElement(
								'div',
								{ className: "position-relative" },
								_react2.default.createElement(
									'a',
									{ className: 'nav-link-loc font-weight-bold',
										'data-toggle': 'dropdown',
										tabIndex: 2,
										href: "#",
										onClick: function onClick(event) {
											return event.preventDefault();
										}
									},
									_react2.default.createElement('i', { className: 'icofont-location-pin' }),
									' ',
									locationName
								),
								this.renderLocationChangeComponent()
							)
						) : null,
						_react2.default.createElement(
							'li',
							{ className: 'nav-item dropdown dropdown-cart', key: "order-type" },
							_react2.default.createElement(
								'div',
								{
									className: 'position-relative klCtnb-btn ' + (businessSupportMultiLocations ? "ml-15" : ""),
									onClick: this.handleShowScheduleOrderModal
								},
								_react2.default.createElement(
									'div',
									{ className: 'btn-group-loc' },
									this.getPickUpTab(),
									this.getDeliveryTab(),
									this.getDineInTab()
								)
							)
						)
					)
				)
			);
		}
	}, {
		key: 'handleLogOut',
		value: function handleLogOut(e) {
			e.preventDefault();
			Utils.showSpinner();
			var history = this.props.history;

			var params = this.props.params;
			var locId = this.props.params.locId;
			Utility.logOut(history, locId, true);
		}
	}, {
		key: 'changeModalTitle',
		value: function changeModalTitle(title) {
			this.setState({ title: title });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this,
			    _React$createElement3;

			var isLogoSameForAllLocation = _MainStore2.default.isLogoSameForAllLocation();
			var logo = "";
			var isMobile = this.state.isMobile;
			var businessData = _MainStore2.default.getMainScreenDataSet();
			var businessLocations = [];
			var businessSupportMultiLocations = false;

			if (!Utils.isEmptyObj(businessData)) {

				if (businessData.BusinessLocations.length > 1) {
					businessLocations = businessData.BusinessLocations;
					businessSupportMultiLocations = true;
				}
			}

			if (isLogoSameForAllLocation && isLogoSameForAllLocation == true) {
				var businessDetail = _MainStore2.default.getBusinessDetail();
				logo = Utility.getLogoUrl(businessDetail);
			} else {
				var activeLocation = _MainStore2.default.getActiveLocation();
				logo = Utility.getLogoUrl(activeLocation);
			}

			var navbarClass = "navbar navbar-expand-lg navbar-light bg-light osahan-nav w-100 animate fixed-top";

			if (window.location.href.includes('/checkout') || window.location.href.includes('/success')) {
				navbarClass = "navbar navbar-expand-lg navbar-light bg-light osahan-nav w-100" + " animate ";
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(node) {
						return _this3.node = node;
					}, className: "w-100" },
				_react2.default.createElement(
					'nav',
					{
						className: navbarClass,
						style: { zIndex: "1000" },
						id: "navBarTop"
					},
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						isMobile ? _react2.default.createElement(
							'div',
							{ className: "mobView" },
							businessSupportMultiLocations ? this.renderLocationAndOrderTypeMobComponent() : null,
							_react2.default.createElement(
								'div',
								{ className: "position-relative d-inline-block mob-loc-dropdown" + " ml-2" },
								_react2.default.createElement(
									'a',
									{ className: 'nav-link-loc btn-styl position-relative mob-cart-dropdown btn-loc-dark',
										onClick: this.handleShowScheduleOrderModal
									},
									_react2.default.createElement('i', { className: 'icofont-ui-edit' }),
									' ',
									this.state.orderType
								)
							),
							!window.location.href.includes('/checkout') ? _react2.default.createElement(
								'div',
								{ className: "pull-right position-relative d-inline-block" + " mob-cart-dropdown" + " ml-2" },
								_react2.default.createElement(
									'a',
									{ className: 'nav-link-loc bg-white position-relative mob-cart-dropdown mob-cart-box btn-loc-dark',
										onClick: this.handleCheckout,
										href: "#"
									},
									_react2.default.createElement('i', { className: 'fa fa-shopping-basket text-dark ft-18' }),
									_react2.default.createElement(
										'span',
										{ className: 'badge ml-1 bg-styl mob-cart-badge' },
										_CartStore2.default.getCartCount()
									)
								)
							) : null
						) : _react2.default.createElement(
							'a',
							{ className: 'navbar-brand pt-2 pb-2 mr-4 cursor-pointer', onClick: function onClick(event) {
									return _this3.handlePastOrders(event, "home");
								}, tabIndex: 1 },
							_react2.default.createElement('img', { alt: 'locationLogo', src: logo, height: '50' })
						),
						_parse2.default.User.current() || !window.location.href.includes('/checkout') ? _react2.default.createElement(
							'button',
							{ className: 'navbar-toggler', type: 'button', 'data-toggle': 'collapse',
								'data-target': '#navbarNavDropdown', 'aria-controls': 'navbarNavDropdown',
								'aria-haspopup': 'true', 'aria-label': 'Toggle navigation' },
							_react2.default.createElement('span', { className: 'navbar-toggler-icon' })
						) : null,
						!isMobile ? this.renderLocationAndOrderTypeComponent(businessSupportMultiLocations) : null,
						_react2.default.createElement(
							'div',
							{ className: 'collapse navbar-collapse', id: 'navbarNavDropdown' },
							_react2.default.createElement(
								'ul',
								{ className: 'navbar-nav ml-auto' },
								!window.location.href.includes('/checkout') ? _react2.default.createElement(
									'li',
									{ className: 'nav-item dropdown', key: "info" },
									_react2.default.createElement(
										'a',
										_defineProperty({ className: 'nav-link ft-14 text-dark cursor-pointer',
											'aria-haspopup': 'true', tabIndex: 0, onClick: this.handleShowRestaurantInfoModal,
											href: ""
										}, 'tabIndex', 4),
										_react2.default.createElement('i', { className: 'icofont-info-circle' }),
										' Info'
									)
								) : null,
								_parse2.default.User.current() ? _react2.default.createElement(
									'li',
									{ className: 'nav-item dropdown', key: "my-account" },
									_react2.default.createElement(
										'a',
										(_React$createElement3 = { className: 'nav-link ft-14 text-dark dropdown-toggle cursor-pointer', role: 'button',
											'data-toggle': 'dropdown', 'aria-haspopup': 'true', tabIndex: 0
										}, _defineProperty(_React$createElement3, 'aria-haspopup', 'true'), _defineProperty(_React$createElement3, 'href', "#"), _defineProperty(_React$createElement3, 'onClick', function onClick(event) {
											return event.preventDefault();
										}), _defineProperty(_React$createElement3, 'tabIndex', 5), _React$createElement3),
										'My Account'
									),
									_react2.default.createElement(
										'div',
										{ className: 'dropdown-menu dropdown-menu-right shadow-sm border-1 cursor-pointer', id: "accountDropDown" },
										_react2.default.createElement(
											'a',
											{ className: 'dropdown-item text-dark',
												onClick: function onClick(event) {
													return _this3.handlePastOrders(event, "profile");
												},
												href: "#",
												tabIndex: 5
											},
											_react2.default.createElement(
												'i',
												{ className: 'icofont-ui-user' },
												' '
											),
											' My Profile'
										),
										_react2.default.createElement(
											'a',
											{ className: 'dropdown-item text-dark',
												onClick: function onClick(event) {
													return _this3.handlePastOrders(event, "orders");
												},
												href: "#",
												tabIndex: 5
											},
											_react2.default.createElement('i', { className: 'icofont-food-cart' }),
											' Orders'
										),
										_react2.default.createElement(
											'a',
											{ className: 'dropdown-item text-dark',
												onClick: function onClick(event) {
													return _this3.handlePastOrders(event, "payments");
												},
												href: "#",
												tabIndex: 5
											},
											_react2.default.createElement('i', { className: 'icofont-credit-card' }),
											' Payments'
										),
										_react2.default.createElement(
											'a',
											{ className: 'dropdown-item text-dark',
												onClick: function onClick(event) {
													return _this3.handlePastOrders(event, "address");
												},
												href: "#",
												tabIndex: 5
											},
											_react2.default.createElement(
												'i',
												{ className: 'icofont-location-pin' },
												' '
											),
											' Addresses'
										),
										_react2.default.createElement(
											'a',
											{ className: 'dropdown-item text-dark',
												onClick: function onClick(event) {
													return _this3.handleLogOut(event);
												},
												href: "#",
												tabIndex: 5
											},
											_react2.default.createElement('i', { className: 'icofont-logout' }),
											' Logout'
										)
									)
								) : null,
								!_parse2.default.User.current() && !window.location.href.includes('/checkout') ? _react2.default.createElement(
									'li',
									{ className: 'nav-item', key: "log-in" },
									_react2.default.createElement(
										'a',
										_defineProperty({ className: 'nav-link ft-14 text-dark cursor-pointer',
											role: 'button', 'aria-haspopup': 'true',
											onClick: this.handleLogin,
											href: "#",
											tabIndex: 5
										}, 'tabIndex', 5),
										_react2.default.createElement('i', { className: 'fa fa-user mr-1' }),
										'Log In'
									)
								) : null,
								!window.location.href.includes('/checkout') && !isMobile ? _react2.default.createElement(
									'li',
									{ className: 'nav-item', key: "cart" },
									_react2.default.createElement(
										'a',
										{ className: 'nav-link dropdown text-dark cursor-pointer text-dark ft-14',
											onClick: this.handleCheckout,
											href: "#",
											tabIndex: 6
										},
										_react2.default.createElement('i', { className: 'fa fa-shopping-basket' }),
										' Cart',
										this.state.cartBadge > 0 ? _react2.default.createElement(
											'span',
											{ className: 'badge bg-styl text-white ml-1' },
											_CartStore2.default.getCartCount()
										) : null
									)
								) : null
							)
						)
					)
				),
				this.state.showRestaurantInfoModal ? _react2.default.createElement(_RestaurantInfoModal2.default, {
					callBackParent: this.handleHideModal
				}) : null,
				this.state.showLoginModal ? _react2.default.createElement(
					'div',
					{ className: 'modal fade', id: 'loginModal', tabIndex: '-1', role: 'dialog',
						'aria-labelledby': 'loginModalTitle', 'aria-hidden': 'true',
						'data-keyboard': 'false', 'data-backdrop': 'static'
					},
					_react2.default.createElement(
						'div',
						{ className: 'modal-dialog modal-dialog-centered', role: 'document'
						},
						_react2.default.createElement(
							'div',
							{ className: 'modal-content' },
							_react2.default.createElement(
								'div',
								{ className: 'modal-header' },
								_react2.default.createElement(
									'h5',
									{ className: 'modal-title font-weight-bold mt-0 text-center', id: 'exampleModalLongTitle' },
									this.state.title
								),
								_react2.default.createElement(
									'button',
									{ type: 'button', className: 'close', 'data-dismiss': 'modal', 'aria-label': 'Close', onClick: this.handleHideModal },
									_react2.default.createElement(
										'span',
										{ 'aria-hidden': 'true' },
										'\xD7'
									)
								)
							),
							_react2.default.createElement(
								'div',
								{ className: "modal-body" },
								_react2.default.createElement(_LoginForm2.default, {
									logo: logo,
									callbackParent: this.loginInformation,
									changeModalTitle: this.changeModalTitle,
									enableProfileEdit: true,
									history: this.props.history,
									locId: this.props.params.locId
								})
							)
						)
					)
				) : null,
				this.state.ShowScheduleOrderModal ? _react2.default.createElement(_ScheduleOrderModal2.default, {
					callBackParent: this.handleHideModal,
					history: this.props.history,
					locId: this.props.params.locId
				}) : null
			);
		}
	}]);

	return Header;
}(_react2.default.Component);

//create highter order component.


var HOC_NAVIGATION = withReactRouter(Header);
exports.default = HOC_NAVIGATION;


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Header.jsx
// module id = 535
// module chunks = 0